export default __webpack_public_path__ + "static/media/gold-tea.934054ab.png";